import { clsx } from 'clsx'
import { type FC } from 'react'
import { type SetRequired } from 'type-fest'

import { Button, type ButtonProps } from 'base-ui'

import styles from './ProductBuyBoxButton.module.css'

type ProductBuyBoxButtonProps = SetRequired<
  Omit<ButtonProps, 'size' | 'variant'>,
  'startIcon'
>

export const ProductBuyBoxButton: FC<ProductBuyBoxButtonProps> = (props) => {
  const { children, className, ...rest } = props

  return (
    <Button
      className={clsx(styles['product-buy-box-button'], className)}
      size="medium"
      variant="text"
      {...rest}
    >
      {children}
    </Button>
  )
}
